"use client"
import team from "../../assets/worker.png"
import prof from "../../assets/Vector.png"
import invest from "../../assets/investorRel.png"
import styles from "../../styles/AboutUs.module.css"

const HeroSection = ({
  showCompanyProfile,
  setShowCompanyProfile,
  showInvestorRelation,
  setShowInvestorRelation,
  handleCompanyProfileClick,
  handleInvestorClick,
}) => {
  return (
    <div
      className={styles.hero}
      style={{
        overflow: "hidden",
        display: "flex",
        marginTop: 0,
        flexDirection: "column",
      }}
    >
      {/* Revolutionizing Payment Experiences */}
      <div
        className={styles.top}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h1
          style={{
            overflow: "hidden",
            fontSize: "32px",
            color: "black",
            marginBottom: 0,
            lineHeight: 1.2,
            flex: 1,
            fontWeight: 700,
          }}
        >
          Revolutionizing Payment <br />
          Experiences
        </h1>
        <p
          style={{
            fontSize: "16px",
            color: "black",
            lineHeight: 1.7,
            marginBottom: 0,
            textAlign: "left",
            flex: 1,
          }}
        >
          Arifpay is a leading fintech in Ethiopia. We guide you through the evolving commerce landscape, where digital players, expanded services, and
          verticalization are transforming payments. We're a trusted partner to financial institutions, retail chains,
          and small merchants, offering simple and reliable payment solutions.
        </p>
      </div>

      {/* LET'S MEET */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            className={styles.image}
            style={{
              width: "65%",
              height: "auto",
              borderRadius: "10px",
              overflow: "hidden",
              maxWidth: "80%",
              position: "relative",
            }}
          >
            <img
              src={team || "/placeholder.svg"}
              alt="Our Team"
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "35px",
              }}
            />
            {/* Company Profile Button */}
            <div
              className={styles.companyProfileButton}
              onMouseEnter={() => setShowCompanyProfile(true)}
              onMouseLeave={() => setShowCompanyProfile(false)}
              onClick={handleCompanyProfileClick}
              style={{
                position: "absolute",
                bottom: "20px",
                right: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10,
              }}
            >
              {!showCompanyProfile && (
                <img
                  src={prof || "/placeholder.svg"}
                  alt="Company Profile Icon"
                  style={{
                    width: "45px",
                    marginRight: "10px",
                    padding: "3px",
                    marginTop: "20px",
                    backgroundColor: "white",
                    height: "30.04px",
                    objectFit: "contain",
                    display: "block",
                    borderRadius: "10px",
                  }}
                />
              )}
              {showCompanyProfile && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: "10px 20px",
                    border: "1px solid #eee",
                    backgroundColor: "white",
                    borderRadius: "15px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    width: "200px",
                    height: "30px",
                    opacity: showCompanyProfile ? 1 : 0,
                    transition: "opacity 0.3s ease-in-out",
                    whiteSpace: "nowrap",
                    zIndex: 11,
                  }}
                >
                  <img
                    src={prof || "/placeholder.svg"}
                    alt="Company Profile Icon"
                    style={{
                      backgroundColor: "white",
                      marginRight: "15px",
                      marginLeft: "0",
                      marginTop: "0px",
                      width: "50px",
                      height: "40px",
                      objectFit: "contain",
                    }}
                  />
                  <strong style={{ color: "black" }}>Company Profile</strong>
                </div>
              )}
            </div>
            {/* Investor Relations Button */}
            <div
              className={styles.investorButton}
              onMouseEnter={() => setShowInvestorRelation(true)}
              onMouseLeave={() => setShowInvestorRelation(false)}
              onClick={handleInvestorClick}
              style={{
                position: "absolute",
                bottom: "30px",
                right: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10,
              }}
            >
              {!showInvestorRelation && (
                <img
                  src={invest || "/placeholder.svg"}
                  alt="Investor Relation Icon"
                  style={{
                    width: "98px",
                    height: "91.04px",
                    objectFit: "contain",
                    display: "block",
                    borderRadius: "10px",
                  }}
                />
              )}
              {showInvestorRelation && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: "10px 20px",
                    backgroundColor: "white",
                    border: "1px solid #eee",
                    borderRadius: "15px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    width: "200px",
                    height: "30px",
                    opacity: showInvestorRelation ? 1 : 0,
                    transition: "opacity 0.3s ease-in-out",
                    whiteSpace: "nowrap",
                    zIndex: 11,
                  }}
                >
                  <img
                    src={invest || "/placeholder.svg"}
                    alt="Investor Relation Icon"
                    style={{
                      marginRight: "5px",
                      marginLeft: "0",
                      marginTop: "38px",
                      width: "100px",
                      height: "90px",
                      objectFit: "contain",
                    }}
                  />
                  <strong style={{ color: "black" }}>Investor Relation</strong>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
